export const isEmptyGuid = (guid: string) =>
    guid === '' || guid === '00000000-0000-0000-0000-000000000000';
